import React, { useEffect, useState } from 'react'


import { getUserByEmail } from '../../services/user/user'
import { getCompanyId } from '../../services/company/company'
import { UserRole } from '../../services/utils/enum'
import { useNavigate } from 'react-router'
import { useLocation } from 'react-router-dom'
import { useToast } from '../../context/Toast';
import { useAuth } from '../../context/AuthContext'
import { useTranslation } from 'react-i18next';

interface RouteMiddlewareProps {
    permissions?: string[]
    element: any
}


const PrivateMiddleware: React.FC<RouteMiddlewareProps> = ({ element }) => {
    const { t } = useTranslation('auth');
    const [hasRelease, setHasRelease] = useState(false);
    const navigate = useNavigate();
    const location = useLocation()
    const { showToast } = useToast()
    const { saveDataVerifyOnStorage, saveDataSignUpOnStorage, SignOut, refreshCurrentUser } = useAuth()
    useEffect(() => {
        const getTokenFromUrl = async () => {
            const queryParams = new URLSearchParams(location.search);
            const url: any = {};
            if (queryParams.get('token')) url.verifyToken = queryParams.get('token');
            if (queryParams.get('email')) url.user = {
                email: queryParams.get('email'),
            };
            if (Object.keys(url).length !== 0) {
                saveDataVerifyOnStorage(url);
                if (queryParams.get('email')) {
                    let result = null;
                    try {
                        result = await getUserByEmail(queryParams.get('email'));
                    } catch (error) {
                        console.warn(error);
                    }
                    const company = result?.company?.Item?.id ? await getCompanyId(result.company.Item.id) : null;
                    const dataToSave = {
                        id: result?.id,
                        email: result?.email,
                        status: result?.status,
                        first_name: result?.first_name,
                        last_name: result?.last_name,
                        role: result?.role,
                        company_visited: company?.Item ?? result?.company?.Item ?? null,
                        user_company: company?.Item ?? result?.company?.Item ?? null,
                    };
                    saveDataSignUpOnStorage(dataToSave);
                    await checkPermissions();
                } else {
                    await checkPermissions();
                }
            } else {
                await checkPermissions();
            }
        };

        const checkPermissions = async () => {
            const authUser = localStorage.getItem('zenbox.identity');
            const user = authUser ? JSON.parse(authUser) : null;
            try {
                if (!user?.user?.id) {
                    showToast(t('errors.managerLoginRequired'), 'info', 5000);
                    navigate('/admin/signup');
                    
                } else {
                    const result = await refreshCurrentUser(user?.user?.id);
                    if (!result) return;

                    if (!result?.role) {
                        showToast(t('errors.permissionPage'), 'error', 5000);
                        navigate('/admin/signup');
                        return;
                    }

                    const role = Number(result.role);
                    const pathname = location.pathname;

                    // Bloqueia group_responsible na página /admin/configuracoes
                    if (role === UserRole.group_responsible && pathname === '/admin/configuracoes') {
                        showToast(t('errors.permissionSettings'), 'error', 5000);
                        navigate('/admin/signup');
                        return;
                    }

                    // Permite apenas sAdmin e admin para qualquer rota, e group_responsible apenas fora de /configuracoes
                    if (role === UserRole.sAdmin || role === UserRole.admin || role === UserRole.group_responsible) {
                        setHasRelease(true);
                    } else {
                        showToast(t('errors.permissionPage'), 'error', 5000);
                        navigate('/admin/signup');
                    }
                }
               
            } catch (error: any) {
                if (error?.response?.data?.error) {
                    switch(error.response.data.error) {
                      case "Erro ao validar o token - zenbox_backend":
                        showToast(t('errors.sessionExpired'), 'info', 7500)
                        setTimeout( () => {
                            showToast(t('errors.redirectToLogin'), 'info', 5000)
                            setTimeout( () => {                                
                                SignOut('/admin/signup');
                            }, 5000);
                        }, 2500);
                        break;
                        
                      default:
                        showToast(t('errors.generic'), 'error', 30000);
                        throw error;
                    }
                
                } else {
                    showToast(t('errors.generic'), 'error', 30000)
                    throw error
                }              
            }
        };

        getTokenFromUrl();
    }, [navigate]);

    return hasRelease ? element : null;
    // return element
};

export default PrivateMiddleware
